var site = site || {};
var generic = generic || {};
(function ($) {
  generic.checkout = {};

  /**
   * The cart is a singleton.  Multicart functionality needs to be extended,
   * where this singleton can provide a single reference to manage n carts.
   *
   * @class Cart
   * @namespace generic.checkout.cart
   *
   * @requires generic.cookie, generic.jsonrpc, generic.Hash
   *
   * @returns singleton cart object
   *
   */
  generic.checkout.Cart = (function(ServiceBus, ServiceBusTopics) {

      /**
       * @private declared dependencies of other js modules
       */
      var Hash = generic.Hash, JsonRpc = generic.jsonrpc, Cookie = generic.cookie;

      /**
       * @private singleton
       */
      var cart;

      /**
       * @private    private classes for mixin to service final api {}
       */
      var Properties = {
          setCookie: false
      },
      Containers = {
          order: new Hash(),
          payments: new Array(),
          carts: new Hash(),
          items: new Array(),
          samples: new Array()
      },
      CartData = {
          totalShoppedItems: 0,
          totalItems: 0
      },
      /**
       * @constant
       */
      CartConstants = {

          transactionParams: {
              transactionFields: {
                  "trans_fields" : ["TRANS_ID", "payments"]
              },
              paymentFields: {
                  "payment_fields" : ["address", "PAYMENT_TYPE", "PAYMENT_AMOUNT", "TRANS_PAYMENT_ID"]
              },
              orderFields: {
                  "order_fields" : ["items", "samples", "address", "TRANS_ORDER_ID"]
              }
          },
          itemTypes: {
              "cart" : {
                   "id": "SKU_BASE_ID",
                   "_SUBMIT" : "cart"
               },
               "GiftCard" : {
                   "id": "GiftCard",
                   "_SUBMIT" : "giftcard"
               },
               "collection" : {
                   "id": "SKU_BASE_ID",
                   "_SUBMIT" : "collection.items"
               },
               "kit" : {
                   "id": "COLLECTION_ID",
                   "_SUBMIT" : "alter_collection"
               },
               "replenishment" : {
                   "id": "SKU_BASE_ID",
                   "_SUBMIT" : "alter_replenishment"
               },
               "favorites" : {
                   "id": "SKU_BASE_ID",
                   "_SUBMIT" : "alter_collection"
               }
          }
      },
      Ops = {
          /**
           * @private Update cart state.
           */
          _updateCartData: function(data){

              var self = this;
              var enablePgRestApiAtb = Drupal?.settings?.pg_rest_api?.cart?.enabled;
              var orderItems = '';
              var orderContents = {};

              this.data = data;
              this.defaultCartId = data.default_cart_id;
              this.payments = data?.trans?.payments ? $.makeArray(data.trans.payments) : null;
              this.order = data.order;

              if (enablePgRestApiAtb) {
                  this.totalItems = data.trans_items_count;
                  orderItems = this.order.items;
                  this.order.items.forEach(function(item) {
                    orderContents[item["sku.SKU_BASE_ID"]] = item.ITEM_QUANTITY;
                  });
                  this.order.contents = orderContents;
              } else {
                  this.totalItems = data.items_count;
              }

              // Contents and sample_contents mirror sku by qty hashes.
              this.order.contents = new Hash();
              this.order.sample_contents = new Hash(); // Not the same as samples.

              if (this.order.items != null) {
                  this.order.items = $.map(this.order.items,
                      function (ele) {
                          return (ele == null ? null : ele)
                      }
                  );
              }

              var items = this.order.items || null;
              var totalShoppedItems = 0;

              if (items != null) {
                  items.forEach(function(item) {
                      if (!item) { return; }
                      totalShoppedItems += item.ITEM_QUANTITY;

                      // Set up contents by cart hashes.
                      var cartID = item.CART_ID;
                      var cart = self.carts.get(cartID);

                      if (!cart) {
                          self.carts.set(cartID, new Hash());
                          cart = self.carts.get(cartID);
                          cart.set('contents', new Hash());
                      }

                      var id = item['product.sku.SKU_BASE_ID'] ? item['product.sku.SKU_BASE_ID'] : item.COLLECTION_ID;
                      cart.get('contents').set(id, item.ITEM_QUANTITY);

                      // Compute per-unit tax (replace with field from JSONRPC result when available).
                      var unitTax = item.APPLIED_TAX / item.ITEM_QUANTITY;
                      item.UNIT_TAX = unitTax;

                      // Set up order contents hash (spans carts).
                      if (item.itemType.toLowerCase() === 'skuitem') {
                          let key = item['sku.SKU_BASE_ID'];
                          let qty = item.ITEM_QUANTITY;
                          self.order.contents[key] = qty;
                      } else if (item.itemType.toLowerCase() === 'kititem') {
                          let key = item.COLLECTION_ID;
                          let qty = item.ITEM_QUANTITY;
                          self.order.contents.set(key, qty);
                      } else {
                        // FUTURE: handle other cart item types (e.g. kits)
                      }
                  });

              }

              this.totalShoppedItems = totalShoppedItems;

              var samples = this.order.samples;

              if (samples != null) {
                  samples.forEach(function (item) {
                      var cartID = item.CART_ID;
                      var cart = self.carts.get(cartID);
                      var skuBaseId = enablePgRestApiAtb ? item['product.sku.SKU_BASE_ID'] : item['sku.SKU_BASE_ID'];
                      var id = skuBaseId || item.COLLECTION_ID;

                      if (!cart) {
                          self.carts.set(cartID, new Hash());
                          cart = self.carts.get(cartID);
                          cart.set('contents', new Hash());
                      }

                      cart.get('contents').set(id, item.ITEM_QUANTITY);

                      // Set up order contents hash (spans carts).
                      if (item.itemType.toLowerCase() === 'sampleitem') {
                          var key = enablePgRestApiAtb ? item['product.sku.SKU_BASE_ID'] : item['sku.SKU_BASE_ID'];
                          var qty = item.ITEM_QUANTITY;
                          self.order.sample_contents.set(key, qty);
                      } else {
                          // Other item types (are likely errors).
                      }
                  });
              }
          }
      };


      /**
       * Wrapper for raw AJAX response with helper methods
       * @private
       * @param {object} rawResponse - the original AJAX response object.
       * @returns {object} an obj with helper methods for accessing response data.
       */
      var wrapAjaxResponse = function(rawResponse) {
          return {
              raw: rawResponse,
              getData: function() {
                  return this.raw;
              },
              getCartResults: function() {
                  return this.raw.result?.value;
              },
              getOrderItems: function() {
                  return this.raw.result?.value?.order?.items || [];
              },
              getMessages: function() {
                  return this.raw.result?.value?.messages || [];
              },
              getAllItems: function() {
                  return this.raw.order?.items || [];
              }
          };
      };

      /**
       * @inner Api class with all the methods to handle cart
       */
      var API = {
          initialize: function(args) {
               $.extend(this, args);
          },
          wrapAjaxResponse: wrapAjaxResponse,

          /**
           * @public getCartTotals
           */
          getCartTotals: function() {

              var cookie = Cookie("cart");
              if (cookie && cookie!==null) {
                 // console.log("generic.cart.getCartTotals cookie: "+Object.toJSON(cookie));
                 $.extend(this, cookie);

                 /**
                  * @events cart:countsUpdated
                  */
                 // generic.events.fire({event:'cart:countsUpdated'});
              } else {
                 // console.log("generic.cart.getCartTotals !cookie");
                 this.getCart();
              }

          },
          /**
           * @public setCookie
           */
          setCookie: function() {
              // console.log("generic.cart.setCookie "+this.totalItems);
              var s  = {
                  totalItems: this.totalItems
              }
              s = JSON.stringify(s);
              Cookie("cart",s, {path:"/"});
          },
          /**
           * @public getCart
           * @returns id of updated cart
           */
          getCart: function(args) {

              //console.log("generic.cart.getCart");
              var self = this;

              if (args != null && args.pageDataKey) {
                  var pageData = generic.page_data(args.pageDataKey);
                  if (pageData.get("rpcdata")) {
                      // console.log( "cart page data found!" );
                      self._updateCartData(pageData.get("rpcdata"));
                      return;
                  }
              }

              var params = {};
              $.extend ( params, self.transactionParams.transactionFields );
              $.extend ( params, self.transactionParams.paymentFields);
              $.extend ( params, self.transactionParams.orderFields);

               var id = generic.jsonrpc.fetch({
                  method : 'trans.get',
                  params: [params],
                  onSuccess:function(jsonRpcResponse) {
                      self._updateCartData(jsonRpcResponse.getValue());
                  },
                  onFailure: function(jsonRpcResponse){
                      //jsonRpcResponse.getError();
                      console.log('Transaction JSON failed to load');
                  }
              });
              return id;

          },
          /**
           * @public updateCart
           *
           * @param {object} onSuccess, onFailure callbacks
           *
           * @returns {number} incremented id uniquely identifying internal operations
           */
          updateCart: function(args) {
            if (!args.params) return null;
        
            var self = this;
            var onSuccess = args.onSuccess || new (function () {})();
            var onFailure = args.onFailure || new (function () {})();

            var itemType = args.params.itemType || 'cart';
            var id = self.itemTypes[itemType].id;
            var method = 'rpc.form';
            var enablePgRestApiAtb = Drupal?.settings?.pg_rest_api?.cart?.enabled;

            var params = {
                '_SUBMIT': self.itemTypes[itemType]["_SUBMIT"]
            };

            // Single id or collection id based on sku array from params.
            if (id == 'SKU_BASE_ID') {
                params[id] = (args.params.skus.length == 1) ? args.params.skus[0] : args.params.collectionId; //MK collections array syntax correct?
            } else if (id == 'COLLECTION_ID') {
                params[id] = args.params.collectionId;
            }

            params["INCREMENT"] = args.params.INCREMENT;
            params["QTY"] = args.params.QTY;

            // Offer Code.
            if (args.params.OFFER_CODE && args.params.OFFER_CODE.length>0) {
                params['OFFER_CODE'] = args.params.OFFER_CODE;
            }

            // Favorites.
            if (args.params.action && args.params.action.length > 0) {
                params['action'] = 'add';
            }

            // Kit.
            if (args.params.action && args.params.action == 'save') {
                params['action'] = 'save';
            }

            // Replenishment.
            if (args.params.REPLENISHMENT_FREQ && args.params.REPLENISHMENT_FREQ >= 0) {
                params['REPLENISHMENT_FREQ'] = args.params.REPLENISHMENT_FREQ;
            }
            if (args.params.add_to_cart && args.params.add_to_cart != 0) {
                params['add_to_cart'] = args.params.add_to_cart;
            }

            // Gift Card.
            if (args.params.ITEM_TYPE && args.params.ITEM_TYPE == 'GiftCard') {
                $.extend(params, args.params);
            }

            // Cart ID if adding to something other than the default cart.
            if (args.params.cart_id && (args.params.cart_id != self.defaultCartId)) {
                params['CART_ID'] = args.params.cart_id;
            }

            // Method.
            if (args.params.method && args.params.method.length > 0 ) {
                method = args.params.method;
            }

            // Save which ID the product was displayed in
            if (args.params.CAT_BASE_ID && args.params.CAT_BASE_ID.length > 0) {
                params["CAT_BASE_ID"] = args.params.CAT_BASE_ID;
            }

            if (enablePgRestApiAtb) {
              return this.updateCartViaRest(args, params, onSuccess, onFailure, id);
            } else {
              return this.updateCartViaRPC(args, params, onSuccess, onFailure, id);
            }
          },

          /**
           * @public updateCartViaRest
           *
           * Sends an Ajax Request to PG Rest API to update the cart.
           *
           * @param {object} args - the arguments object containing parameters and callbacks.
           * @param {object} params - the parameters to send in the REST API request.
           * @param {function} onSuccess - callback invoked on a successful update.
           * @param {function} onFailure - callback invoked on failure.
           * @param {string|number} id - the key from params for identifying the SKU.
           *
           * @returns {Promise} - a promise that resolves with the parsed response from the PUT request.
           */
          updateCartViaRest: function(args, params, onSuccess, onFailure, id) {
              var pgApiTokens = Drupal?.settings?.elc_ecom?.pgApiTokens;
              var regionNumber = Drupal?.settings?.pg_rest_api?.region;
              var endpoint = Drupal?.settings?.pg_rest_api?.cart?.endpoint;
              var self = this;
        
              $.ajax({
                url: `${endpoint}?brand=4&region=${regionNumber}`,
                type: 'GET',
                headers: {
                  Authorization: `Basic ${pgApiTokens.cart}`
                },
                dataType: 'text'
              })
              .then(
                function(getResponseText) {
                  var getData;
                  try {
                    getData = JSON.parse(getResponseText);
                  } catch (e) {
                    console.error("Error parsing GET response:", e);
                    return $.Deferred().reject(e).promise();
                  }

                  // Check if item sku exists in current order.
                  var existingIncrement = false;

                  if (getData?.result?.value?.order?.items && Array.isArray(getData.result.value.order.items)) {
                    getData.result.value.order.items.forEach(function(item) {
                      if (item['sku.SKU_BASE_ID'] === params[id]) {
                        existingIncrement = true;
                      }
                    });
                  }

                  // Add item to cart.
                  return $.ajax({
                    url: `${endpoint}?brand=4&region=${regionNumber}`,
                    type: 'PUT',
                    headers: {
                      Authorization: `Basic ${pgApiTokens.cart}`
                    },
                    data: JSON.stringify({
                      sku_id: params[id],
                      qty: params["QTY"],
                      method: existingIncrement ? 'INCREMENT' : params.method
                    }),
                    contentType: 'application/json',
                    dataType: 'text'
                  });
                },
                function(getError) {
                  onFailure(getError);
                  return $.Deferred().reject(getError).promise();
                }
              )
              .then(
                function(putResponseText) {
                  var parsed;
                  try {
                    parsed = JSON.parse(putResponseText);
                  } catch (e) {
                    onFailure(e);
                    return $.Deferred().reject(e).promise();
                  }

                  var wrappedResponse = generic.checkout.cart.wrapAjaxResponse(parsed);
                  var data = wrappedResponse.getData();
                  var cartResultObj = wrappedResponse.getCartResults();

                  if (data?.result?.value) {
                    self._updateCartData(data.result.value);
                  }

                  if (args.params.itemType === 'favorites') {
                    $(document).trigger("favorites.updated", [parsed]);
                  } else if (args.params.itemType === 'kit') {
                    $(document).trigger("kit.updated", [parsed]);
                  } else if (args.params.itemType === 'replenishment') {
                    $(document).trigger("cart.updated", [cartResultObj]);
                  }

                  onSuccess(parsed);
                  return parsed;
                },
                function(putError) {
                  onFailure(putError);
                  return $.Deferred().reject(putError).promise();
                }
              );

          },

          /**
           * @public updateCartViaRPC
           *
           * Sends a JSON RPC request to update the cart (legacy).
           *
           * @param {object} args - arguments object containing all params and callbacks.
           * @param {object} params - the params to send in the RPC call.
           * @param {function} onSuccess - callback invoked on a successful update.
           * @param {function} onFailure - callback invoked on failure.
           * @param {string|number} id - the key from params for identifying the SKU.
           *
           * @returns {Promise} - a promise that resolves with the JSON RPC response.
           */
          updateCartViaRPC: function(args, params, onSuccess, onFailure, id) {
            var self = this;
            var method = 'rpc.form';
          
            if (args.params.method) {
              method = args.params.method;
            }
        
            return JsonRpc.fetch({
              method: method,
              params: [params],
              onSuccess: function(jsonRpcResponse) {
                var data = jsonRpcResponse.getData();
                var cartResultObj = jsonRpcResponse.getCartResults();
                if (data && data["trans_data"]) {
                  self._updateCartData(data["trans_data"]);
                }
                if (args.params.itemType == 'favorites') {
                  $(document).trigger("favorites.updated", [jsonRpcResponse]);
                }
                if (args.params.itemType == 'kit') {
                  $(document).trigger("kit.updated", [jsonRpcResponse]);
                }
                if (args.params.itemType == 'replenishment') {
                  $(document).trigger("cart.updated", [cartResultObj]);
                }
                onSuccess(jsonRpcResponse);
              },
              onFailure: function(jsonRpcResponse) {
                onFailure(jsonRpcResponse);
              }
            });
          },
          /**
           * @public getItemQty
           * @returns {number}
           */
          getItemQty : function(baseSkuId) {
              if (!this.order.items) return 0;
              /* prototype js code:
              var lineItem = this.order.items.find( function (line) {
                  return line['sku.SKU_BASE_ID'] ==  baseSkuId;
                });
              if (!lineItem) {
                  return 0;
              }
              return lineItem.ITEM_QUANTITY;
              */
              for(i in this.order.items) {

                  if( i['sku.SKU_BASE_ID'] == baseSkuId ) {

                      var lineItem = i;
                      break;
                  }

              }
              if(!lineItem) return 0;
              return lineItem.ITEM_QUANTITY;
          },
          /**
           * @public getBaseSkuIds
           * @returns {array}
           */
          getBaseSkuIds: function() {  //MK: what is this used for?
              //console.log("generic.cart.getBaseSkuIds: "+this.order.items);
              /* prototype js code:
              if (!this.order.items) return new Hash();
              var baseSkuIds = this.order.items.pluck( 'sku.SKU_BASE_ID' ); //MK what about giftcards/collections?
              return baseSkuIds;
              */
              if (!this.order.items) return new Hash();
              var baseSkuIds = [];
              for(i in this.order.items) {
                  baseSkuIds.push(i['sku.SKU_BASE_ID']);
              }
              return baseSkuIds;
          },
          /**
           * @public getSubtotal
           * @returns {number}
           */
          getSubtotal: function() {
              var lineItems = this.order.items;
              if (!this.order.items) return 0;
              var subtotal = 0;
              for (var i=0, len = lineItems.length; i<len; i++) {
                  var lineItem = lineItems[i];
                  subtotal += (lineItem.UNIT_PRICE + lineItem.UNIT_TAX) * lineItem.ITEM_QUANTITY;
              }
              return subtotal;
          },
          /**
           * @public getTotalShoppedItems
           * @returns {number}
           */
          getTotalShoppedItems: function(){ //products and gift cards
             /** var ttl = 0;
              var items = this.order.items;
              if (items != null) {
                  items.each(function(item){
                      if (item && item.ITEM_QUANTITY) {
                          ttl += item.ITEM_QUANTITY;
                      }
                  });
              }
              return ttl;**/
              return this.totalShoppedItems;
          },
          /**
           * @public getTotalSamples
           * @returns {number}
           */
          getTotalSamples: function() {
               var ttl = 0;
               var samples = this.order.samples;
                  if (samples != null) {
                      samples.each(function(item){
                          ttl += item.ITEM_QUANTITY;
                      });
              }
              return ttl;
          },
          /**
           * @public getTotalItems
           * @returns {number}
           */
          getTotalItems: function(){
             // return this.getTotalShoppedItems() + this.getTotalSamples();
             return this.totalItems;
           }

      };

      canEmitEvent = function(event) {
        return !!ServiceBus && ServiceBus.emit && ServiceBusTopics && ServiceBusTopics.events && ServiceBusTopics.events[event];
      }

      $(document).on("addToCart.success", function() {
        if (canEmitEvent('CART_UPDATED')) {
          ServiceBus.emit(
            ServiceBusTopics.events.CART_UPDATED
          );
        }
      });

      $(document).on('addToCart.failure', function() {
        if (canEmitEvent('CART_FAILURE')) {
          ServiceBus.emit(
            ServiceBusTopics.events.CART_FAILURE
          );
        }
      });

      cart = $.extend(cart,API,Ops,CartConstants,CartData,Containers,Properties);

      var extra = {
          sample : function(){alert('sample');}
      }

      return function(){

          if(cart) { return cart; }

          // initial and only-time singleton reference
          cart = $.extend(this,cart);
          cart.api = extra.sample;

      };

  }(window.GlobalServiceBus || {},
    window.ServiceBusTopics || {}));


  generic.checkout.cart = new generic.checkout.Cart();
  $(document).on('perlgem.cart.addItem', function(e, skuBaseId, payload) {
    payload = typeof payload !== 'undefined' ? payload : {};
    const args = {};

    // Set sku base id
    args.skuBaseId = skuBaseId;

    // Set quantity
    args.quantity = payload.quantity ? payload.quantity : 1;

    // Set catBaseId
    args.CAT_BASE_ID = payload.CAT_BASE_ID ? payload.CAT_BASE_ID : '';

    // Set replenishment if it exists
    const frequency = payload.replenishment ? payload.replenishment : null;
    if (!!frequency) {
      args.REPLENISHMENT_FREQ = frequency;
    }
    site.addToCart(args);
  });
})(jQuery);

